import Vue from 'vue';
import loader from "./loader";
import noRecordTemplate from "./noRecordTemplate";
import index from '../components/skeletonLoader/index'

Vue.component('noRecordTemplate',noRecordTemplate);
Vue.component('loader', loader);
Vue.component('skeletonLoader', index);